<template>
    <div class="file">
        <div style="width: 100%;height: 100%;font-size: 12px;padding: 10px" v-if="type === 0">
            {{ content }}
        </div>
        <el-image v-if="type === 2" style="width: 100%" fit="cover"
                  :src="content" class="image">
        </el-image>
        <video-player
                v-if="type === 3"
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="content"
        ></video-player>
    </div>
</template>

<script>

export default {
  name: 'userTags',
  props: {
    type: {
      type: Number,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tags: []
    }
  },
  watch: {},
  mounted () {

  },
  methods: {}
}
</script>

<style scoped>
.title {
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;
}

.subtitle {
    font-size: 12px;
    color: #999;
    margin-bottom: 20px;
}
</style>
